import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
import DownloadAppSection from '../global/DownloadAppSection';
import EmptySlider from '../sliders/EmptySlider';
import defaultSliderGlobalImage from "../../assets/static/support.png"; // Adjust path based on file location


function PersonalLoans() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
      <EmptySlider 
        title="Personal Loans? We’ve got you covered." 
        description="Kontriman has many ways to get you the answer you need – help centre, chat support and email. Get help whenever, wherever." 
        imageUrl={defaultSliderGlobalImage}
    />
    {/* 
    Content for about how kontriman loans works will be placed here
    
    */}
      <DownloadAppSection></DownloadAppSection>
      <Footer></Footer>
    </div>
  );
}

export default PersonalLoans;
